<!-- 修改 -->
<template>
  <div class="apply" v-loading="loading">
    <back />
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基本信息:</div>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item class="item" label="项目名称" prop="projectName">
              <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item class="item" label="定价(元)" prop="price">
              <el-input v-model="ruleForm.price" placeholder="请输入定价(元)" @change="showPrice"></el-input>
            </el-form-item>

            <el-form-item class="item logo_pic" label="项目图片" prop="picUrl1">
              <div class="pic-row">
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess1" :before-upload="beforeUploads" :on-remove="handleRemoveLogo1" :disabled="ruleForm.picUrl1 ? true : false">
                    <img v-if="ruleForm.picUrl1" :src="ruleForm.picUrl1" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl1" class="delpic delpic1 el-icon-error" @click="handleRemoveLogo1"></i>
                </div>
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess2" :before-upload="beforeUploads" :on-remove="handleRemoveLogo2" :disabled="ruleForm.picUrl2 ? true : false">
                    <img v-if="ruleForm.picUrl2" :src="ruleForm.picUrl2" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl2" class="delpic delpic2 el-icon-error" @click="handleRemoveLogo2"></i>
                </div>
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess3" :before-upload="beforeUploads" :on-remove="handleRemoveLogo3" :disabled="ruleForm.picUrl3 ? true : false">
                    <img v-if="ruleForm.picUrl3" :src="ruleForm.picUrl3" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl3" class="delpic delpic3 el-icon-error" @click="handleRemoveLogo3"></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="项目分类" prop="categoryId">
              <el-cascader v-model="ruleForm.secondCategoryId" :options="categoryListData" placeholder="选择项目分类" :props="{ expandTrigger: 'hover', label: 'categoryName', value: 'categoryId', children: 'children', emitPath: false, checkStrictly: false }" clearable></el-cascader>
            </el-form-item>
            <el-form-item class="item" label="划线价(元)" prop="linePrice" :hide-required-asterisk="false">
              <el-input v-model="ruleForm.linePrice" placeholder="请输入划线价(元)" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="服务时长(min)" prop="durationMinute">
              <el-input v-model="ruleForm.durationMinute" placeholder="请输入服务时长(min)"></el-input>
            </el-form-item>
            <el-form-item class="item" label="次数:" prop="projectCount">
              <el-input v-model.number="ruleForm.projectCount" placeholder="请输入次数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title">项目详情:</div>
        <el-row class="dialog_row">
          <el-col>
            <el-form-item class="item" label="服务部位">
              <el-input v-model="ruleForm.serviceLocation" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col>
            <!-- <div class="btn">
              <div style="margin-left: 80px; font-size: 14px;color: #606266;">服务流程:</div>
              <div><el-button type="primary" @click="showAddDialog">添加</el-button></div>
            </div>
            <div class="g_table" style="margin-left: 80px;margin-bottom: 20px; overflow: auto">
              <el-table :data="tableData">
                <el-table-column prop="number" label="服务步骤">
                  <template slot-scope="scope">
                    <span type="primary">{{scope.$index+1}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="processName" show-overflow-tooltip label="服务内容"></el-table-column>
                <el-table-column prop="durationMinute" label="服务时长（min)"></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="primary" size="small" plain @click="editRow(scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" plain @click="deleteRow(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div> -->
             <el-form-item class="item logo_pic" label="服务流程" prop="processPic">
              <div class="pic-row">
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess4" :before-upload="beforeUploads" :on-remove="handleRemoveLogo4" :disabled="ruleForm.processPic ? true : false">
                    <img v-if="ruleForm.processPic" :src="ruleForm.processPic" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.processPic" class="delpic delpic1 el-icon-error" @click="handleRemoveLogo4"></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col>
            <el-form-item class="item" label="注意事项">
              <el-input v-model="ruleForm.explainDesc" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col>
            <el-form-item label="项目介绍" prop="introduction">
              <vue-word-editor v-model="ruleForm.introduction" :config="config" ref="wordeditor"></vue-word-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="title">提成信息:</div>

        <div style="display: flex;">
          <div style="width:500px ;">
            <el-radio v-model="radio" label="1" @change="onchange(1)">
              <span>提成比例(%): </span>
              <el-input v-model.number="ruleForm.commissionRate" placeholder="请输入" :disabled="radio=='2'" type="number" @blur="bb($event)"></el-input>
            </el-radio>
          </div>
          <div>
            <el-radio v-model="radio" label="2" @change="onchange(2)">
              <span>提成金额(元): </span>
              <el-input v-model="ruleForm.commissionAmount" placeholder="请输入" :disabled="radio=='1'" @blur="aa($event)" type="number"></el-input>
            </el-radio>
          </div>
        </div>
        <el-divider></el-divider>
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div style="font-size: 20px; font-weight: bold;">分账设置:</div>
          <div><el-button type="primary" @click="handelAll" :disabled="multipleSelection.length==0">批量设置</el-button></div>
        </div>
        <div class="g_table" style="margin-bottom: 20px; overflow: auto">
          <el-table :data="dataList" max-height="350" :row-key="row => row.storeId" ref="multipleTable" @selection-change="handleSelection">
            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column label="序号" show-overflow-tooltip width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column min-width="200" show-overflow-tooltip prop="storeName" label="门店名称"></el-table-column>
            <el-table-column min-width="200" show-overflow-tooltip prop="address" label="门店地址"></el-table-column>
            <el-table-column min-width="120" align="center" show-overflow-tooltip prop="storeRate" label="门店分账比例(%)">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.storeRate" placeholder="请输入门店分账比例(%)" @change="handleBox(scope.row)" :disabled="!isSelected(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination> -->

      </div>

      <div class="submit-btn">
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button type="primary" plain @click="$router.go(-1)">取消</el-button>
      </div>
    </el-form>

    <el-dialog title="添加数据" :visible.sync="addDialogVisible" :before-close="()=>{addDialogVisible=false}">
      <el-form :model="newData" :rules="rulesData" ref="newData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务内容" prop="processName">
              <el-input v-model="newData.processName" placeholder="请输入服务内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务时长" prop="durationMinute">
              <el-input v-model="newData.durationMinute" placeholder="请输入服务时长（min）"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="addData('newData')">确 定</el-button>
        <el-button @click="resetData('newData')">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑数据" :visible.sync="editDialogVisible" :before-close="()=>{editDialogVisible=false}">
      <el-form :model="editData" :rules="rulesEditData" ref="editData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务内容" prop="processName">
              <el-input v-model="editData.processName" placeholder="请输入服务内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务时长" prop="durationMinute">
              <el-input v-model="editData.durationMinute" placeholder="请输入服务时长（min）"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="saveEditedData('editData')">确 定</el-button>
        <el-button @click="resetEditData('editData')">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量设置" :visible.sync="dialogShow" :before-close="()=>{dialogShow=false}">
      <el-form :model="newData1" :rules="rulesData1" ref="newData1" label-width="180px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="门店分账比例(%)" prop="storeRate">
              <el-input v-model.number="newData1.storeRate" placeholder="请输入整数0-100"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="addData1('newData1')">确 定</el-button>
        <el-button @click="handelCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueWordEditor from "vue-word-editor";
import "quill/dist/quill.snow.css"
export default {
  components: {
    VueWordEditor,
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的行数
      pageSizeArr: [5, 10, 15], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      tableData: [],
      dataList: [],
      editData: {},
      radio: '1',
      editDialogVisible: false,
      newData: { processName: '', durationMinute: '' },
      newData1: { storeRate: '', },
      addDialogVisible: false,
      categoryListData: [],
      cachedData: null,
      loading: false,
      id: '',
      radio1: '',
      radio2: '',
      ruleForm: {
        price: '',
        projectName: '', // 名称
        durationMinute: '', // 
        linePrice: '', // 划线价
        picUrl1: "", //商品图片
        picUrl2: "", //商品图片
        picUrl3: "", //商品图片
        processPic:"",//服务流程
        introduction: "", //介绍
        franchiseesCategoryId: '',//商品类目
        platformCategoryName: '',// 平台类目
        explainDesc: '',
        serviceLocation: '',
        commissionAmount: '',
        commissionRate: '',
        projectCount:""
      },

      rules: {
        price: [
          { required: true, message: '请先输入划线价且不能大于划线价，只能输入数字保留两位小数', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^([0-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value) == false) {
                callback(new Error("请先输入划线价且不能大于划线价，只能输入数字保留两位小数"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        linePrice: [
          { required: false, message: '请输入数字且只能保留两位小数', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^([0-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value) == false) {
                callback(new Error("请输入数字且只能保留两位小数"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        secondCategoryId: [
          { required: true, message: '请选择商品类目', trigger: 'change' },
        ],
        picUrl1: [
          { required: true, message: '请上传图片', trigger: 'change' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'change' },
        ],
        durationMinute: [
          { required: true, message: '请输入服务时长(min)', trigger: 'change' },
        ],
        projectCount: [
          { required: true, message: '请输入数字', trigger: 'blur' },
        ],
      },
      rulesData: {
        durationMinute: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value) == false) {
                callback(new Error("请输入数字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        processName: [
          { required: true, message: '请输入服务内容', trigger: 'change' },
        ],
      },
      rulesData1: {
        storeRate: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              // 正则验证0-100数字
              if (/^(100|[1-9]?[0-9])$/.test(value) == false) {
                callback(new Error("请输入数字且只能0-100"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],


      },
      rulesEditData: {
        durationMinute: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value) == false) {
                callback(new Error("请输入数字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        processName: [
          { required: true, message: '请输入服务内容', trigger: 'change' },
        ],
      },
      // 图片上传
      fileList: [],
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      config: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link", "image"],
            [{
              header: 1
            }, {
              header: 2
            }], // custom button values
            [{
              list: "ordered"
            },
            {
              list: "bullet"
            },
            {
              list: "check"
            },
            ],
            [{
              script: "sub"
            }, {
              script: "super"
            }], // superscript/subscript
            [{
              indent: "-1"
            }, {
              indent: "+1"
            }], // outdent/indent
            [{
              direction: "rtl"
            }], // text direction
          ],
        },
        // 上传图片的配置
        uploadImage: {
          url: this.$axios.defaults.baseURL + this.$api.uploadFile,
          name: "multipartFile",
          // res是结果，insert方法会把内容注入到编辑器中，res.data.url是资源地址
          uploadSuccess: (res, insert) => {
            if (res.data.code !== 100) {
              this.$message.error("请上传图片格式，如JPG，JPEG，PNG文件格式");
            } else {
              insert(res.data.result.fileUrl);
            }
          },
          showProgress: false,
        },
      },
      multipleSelection: [],
      dialogShow: false

    }
  },
  created() {
    this.getDataList()
    this.getCategoryInfoList()
    this.getCachedData();
    this.getSelectProjectInfo();

    
  },
  watch: {
    // 监听 dataList 的变化，确保数据更新时及时响应
    dataList: {
      handler(newValue) {
        this.dataList = newValue;
      },
      deep: true,
    },
  },
  methods: {
    showPrice() { 
      // console.log(Number(this.ruleForm.linePrice));
      // console.log(Number(this.ruleForm.price));
      // 判断划线价不能大于定价,大于定价则清空划线价 
      if ((Number(this.ruleForm.price) > Number(this.ruleForm.linePrice))) {
        this.$message.error('请先输入划线价且不能大于划线价');
        this.ruleForm.price = '';
        return false;
      }

    },
    // 批量设置
    handelAll() {
      this.dialogShow = true
      this.multipleSelection.forEach(item => {
        item.storeRate = this.inputValue
      })
    },
    addData1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$set(this.dataList, this.dataList.indexOf(this.multipleSelection[0]), this.multipleSelection[0]);
          this.dataList = this.dataList.map(item => {
            // 判断item 是否存在multipleSelection 通过 storeId判断
            const condition = this.multipleSelection.some(item1 => item1.storeId === item.storeId)
            if (condition) {
              item.storeRate = this.newData1.storeRate
            }
            return item
          })
          this.multipleSelection.forEach(item => {
            item.storeRate = this.newData1.storeRate
          })
          this.dialogShow = false
          this.newData1 = {}
        }
      })
    },
    handelCancel() {
      this.$refs.newData1.resetFields()
      this.dialogShow = false
    },
    // 选中数据
    handleSelection(val) {
      this.multipleSelection = val.map(t => ({
        storeRate: t.storeRate,
        storeId: t.storeId,
        // disabled: false
      }))
      this.$set(this.dataList, this.dataList.indexOf(val[0]), val[0]);
      // console.log("选中", this.multipleSelection);



    },
    isSelected(row) {
      // console.log(this.multipleSelection);
      return this.multipleSelection.some(item => item.storeId === row.storeId);

    },
    handleBox(row) {
      // console.log(row);
      const index = this.multipleSelection.findIndex(item => item.storeId === row.storeId);
      if (index !== -1) {
        this.$set(this.multipleSelection, index, {
          storeRate: Number(row.storeRate),
          storeId: row.storeId,
        });
        // console.log('修改后选中', this.multipleSelection);
      }
      let boolean = new RegExp("^[0-9][0-9]*$").test(row.storeRate)
      if (!boolean || (row.storeRate < 0 || row.storeRate > 100)) {
        this.$refs.multipleTable.toggleRowSelection(row, false)
        this.$message.warning("请输入正整数不可以小于0或超过100")
        // 如果不符合要求，row.storeRate恢复旧值
        // row.storeRateDefault = row.storeRate;
        row.storeRate = row.storeRateDefault;
        this.$set(row, 'disabled', true);
        this.$set(this.dataList, this.dataList.indexOf(row[0]), row[0]);
      }
    },

    getDataList() {
      this.$axios.post(this.$api.selectProjectAccountList, {
        projectId: this.$route.query.projectId,
        page: this.currentPage,
        pageSize: 9999
      }).then(res => {
        this.dataList = res.result.list

        this.totalItemsCount = res.result.totalCount
        this.dataList.forEach(item => {
          // this.$set(item, 'disabled', true)
          // item.storeId = item.id
          item.storeRateDefault = item.storeRate
        })

      }).catch(error => {
        console.log(error)
      })
    },

    // 切换每页显示的条数
    handleSizeChange(e) {
      this.dataList = []
      this.pageSize = e
      this.getDataList()
    },
    // 换页
    handleCurrentChange(e) {
      this.dataList = []
      this.currentPage = e
      this.getDataList()
    },
    handelEdit() { },
   aa(e) {
      let b = new RegExp(/^[0-9]+(\.[0-9]{1,2})?$/).test(e.target.value)
      if (!b) {
        this.$message.error("提成金额只能保留两位小数")
        e.target.value = ''
        this.ruleForm.commissionAmount =  e.target.value
      }
    },
    bb(e) {
      let b = new RegExp(/^(100|[0-9]\d?)$/).test(e.target.value)
      if (!b || (Number(e.target.value) > 100)) {
        this.$message.error("提成比例请输入0-100正整数且不可以大于100")
        e.target.value = 0
        this.ruleForm.commissionRate = e.target.value
      }
    },

    // 编辑行数据
    editRow(row) {
      console.log(row);

      this.editDialogVisible = true;
      // 这里可以实现编辑逻辑，例如打开一个编辑对话框并填充当前行数据
      // console.log('编辑行：', row);
      this.editData = { ...row };
      // this.editData.processName = row.processName;
      // this.editData.durationMinute = row.durationMinute;

    },
    // 删除行数据
    deleteRow(row) {
      const index = this.tableData.indexOf(row);
      if (index !== -1) {
        this.tableData.splice(index, 1);
      }

    },
    // 显示添加对话框
    showAddDialog() {
      this.addDialogVisible = true;
    },
    // 添加数据到表格
    addData(newData) {
      this.$refs[newData].validate(valid => {
        if (valid) {
          const newId = this.getNextId();
          const newRow = { id: newId, ...this.newData };
          this.tableData.push(newRow);
          // this.newData.processName = '';
          // this.newData.durationMinute = '';
          this.addDialogVisible = false;
          this.$refs[newData].resetFields();
        }
      });

    },
    // // 保存编辑后的数据
    saveEditedData(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          const index = this.tableData.findIndex(item => item.id === this.editData.id);
          if (index !== -1) {
            this.tableData[index].id = this.editData.id;
            this.tableData[index].processName = this.editData.processName;
            this.tableData[index].durationMinute = this.editData.durationMinute;

          }
          this.$refs[editData].resetFields(),
            this.editDialogVisible = false;
        }
      });
    },
    getNextId() {
      return this.tableData.length > 0 ? Math.max(...this.tableData.map(item => item.id)) + 1 : 1;
    },

    resetData(newData) {
      this.addDialogVisible = false,
        this.$refs[newData].resetFields(),
        this.newData = {}
    },
    resetEditData(editData) {
      this.editDialogVisible = false,
        this.$refs[editData].resetFields(),
        this.editData = {}
    },
    onchange(type) {
      if (type == 1) {
        this.ruleForm.commissionAmount = ''
      } else {
        this.ruleForm.commissionRate = ''
      }
    },
    getCategoryInfoList() {
      this.$axios.get(this.$api.projectList, {
        params: {
          page: this.currentPage,
          pageSize: 9999,
        },
      }).then(res => {
        if (res.code == 100) {
          this.categoryListData = res.result.list
          this.categoryListData.map(item => {
            if (item.children.length == 0) {
              item.children = null
            }
          })
        }
        this.loading = false
      })
    },
    getCachedData() {
      const cachedValue = localStorage.getItem('productList');
      if (cachedValue) {
        this.cachedData = JSON.parse(cachedValue);
      }
    },
    getSelectProjectInfo() {
      this.loading = true;
      this.$axios.get(this.$api.selectProjectInfo, {
        params: {
          projectId: this.$route.query.projectId,
        }
      }).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result;
          this.radio = String(res.result.commissionType);
          this.ruleForm.linePrice = String(res.result.linePrice);
          this.ruleForm.salePrice = String(res.result.salePrice);
          // this.ruleForm.franchiseesCategory =28
          if (this.ruleForm.picList && Array.isArray(this.ruleForm.picList)) {
            this.$set(this.ruleForm, 'picUrl1', this.ruleForm.picList[0] || '');
            this.$set(this.ruleForm, 'picUrl2', this.ruleForm.picList[1] || '');
            this.$set(this.ruleForm, 'picUrl3', this.ruleForm.picList[2] || '');
          } else {
            this.$set(this.ruleForm, 'picUrl1', '');
            this.$set(this.ruleForm, 'picUrl2', '');
            this.$set(this.ruleForm, 'picUrl3', '');
          }
          this.tableData = !res.result.processList ? [] : res.result.processList;
          this.$refs.wordeditor.editor.root.innerHTML = this.ruleForm.introduction;
        }

        this.loading = false;
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })
    },
    // 表单校验
    submitForm(formName) {
      if (!this.ruleForm.commissionRate && !this.ruleForm.commissionAmount) {
        this.$message({
          type: 'error',
          message: '提成比例或提成金额必填一项'
        })
        return false
      }
      if (Number(this.ruleForm.commissionRate) > 100) {
        return this.bb()
      }
      // console.log(this.dataList);

      this.ruleForm.introduction = this.$refs.wordeditor.editor.root.innerHTML
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const processList = this.tableData.map(item => {
            return {
              durationMinute: item.durationMinute,
              processName: item.processName
            }
          })
          this.dataList = this.dataList.map(item => {
            return {
              storeId: item.storeId,
              storeRate: item.storeRate
            }
          })
          this.$axios.post(this.$api.updateProjectInfo, {
            // salePrice: this.ruleForm.salePrice,
            accountDtoList: this.dataList,
            projectCount:this.ruleForm.projectCount,
            serviceLocation: this.ruleForm.serviceLocation,
            introduction: this.ruleForm.introduction,
            picList: [this.ruleForm.picUrl1 || null, this.ruleForm.picUrl2 || null, this.ruleForm.picUrl3 || null],
            processPic:this.ruleForm.processPic || '',
            commissionAmount: this.ruleForm.commissionAmount,
            commissionRate: this.ruleForm.commissionRate,
            commissionType: this.radio,
            durationMinute: this.ruleForm.durationMinute,
            explainDesc: this.ruleForm.explainDesc,
            linePrice: this.ruleForm.linePrice,
            price: this.ruleForm.price,
            projectId: this.ruleForm.projectId,
            projectName: this.ruleForm.projectName,
            projectType: this.ruleForm.projectType,
            secondCategoryId: this.ruleForm.secondCategoryId,
            processList: processList
          }).then((res) => {
            if (res.code == 100) {
              this.$message.success(res.desc);
              this.$router.push('/experienceProject/experienceList');
              this.resetForm();
            }
          }).catch((res) => {
            this.$message.error(res.desc);
          })

        } else {
          this.$message.error("提交失败，某一条必填项未输入");
          // console.log('error submit!!');
          return false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
      this.ruleForm.introduction = '';
    },
    handleRemoveLogo1() {
      this.ruleForm.picUrl1 = ""
    },
    handleSuccess1(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl1 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo2() {
      this.ruleForm.picUrl2 = ""
    },
    handleSuccess2(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl2 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo3() {
      this.ruleForm.picUrl3 = ""
    },
    handleSuccess3(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl3 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
     handleRemoveLogo4() {
      this.ruleForm.processPic = ""
    },
    handleSuccess4(res) {
      if (res.code == 100) {
        this.ruleForm.processPic = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },

    validatePrice(rule, value, callback) {
      const reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(value)) {
        callback(new Error(`必须为数字且最多保留两位小数`));
      } else {
        callback();
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.apply {
  // 1.基本信息
  .form {
    margin: 30px 20px;
    ::v-deep .el-cascader {
      width: auto !important;
    }
    .title {
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    ::v-deep .el-cascader {
      width: 367px;
    }
  }

  // 保质期天数
  .day {
    ::v-deep .el-form-item__label {
      color: #606266;
      font-size: 16px;
      padding-right: 30px;
    }

    ::v-deep.el-input__inner {
      background: #ffffff !important;
      border-radius: 10px 0 0 10px;
      border: none;
    }

    ::v-deep .el-input-group__append {
      background: #ffffff !important;
      border-radius: 0px 10px 10px 0;
      border: none;
      font-size: 20px;
      color: #606266;
    }
  }

  .submit-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  // 图片
  .logo_pic {
    position: relative;

    ::v-deep .el-form-item__content {
      width: 100px;
      height: 100px;
    }

    .pic-row {
      display: flex;

      .pic {
        margin-right: 15px;

        .logo_uploader {
          ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          ::v-deep .el-upload:hover {
            border-color: #069bbc;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #069bbc;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }

          .logoimg {
            width: 100px;
            height: 100px;
            display: block;
            object-fit: cover;
          }
        }
      }
    }

    .delpic {
      position: absolute;
      top: -12px;
      color: red;
      font-size: 20px;
      cursor: pointer;
    }

    .delpic1 {
      right: -15px;
    }

    .delpic2 {
      right: -134px;
    }

    .delpic3 {
      right: -250px;
    }
  }
}

// common
.dialog_row {
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  // width: 850px;
  ::v-deep.el-form-item {
    margin-right: 100px;
  }

  ::v-deep.el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }
}

/* input number类型取消增减箭头*/
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

// 光标上移
::v-deep.el-input__inner {
  line-height: 1px !important;
}

::v-deep .ql-editor {
  min-height: 200px;
  max-height: 500px;
}
</style>
